import Base from '../Pages/Base'
import ListCategoriasConcursos2023 from '../Pages/Categorias/List'
import FormCategoriasConcursos2023 from '../Pages/Categorias/Form'
import ListConcursos2023 from '../Pages/Concursos/List'
import FormConcursos2023 from '../Pages/Concursos/Form'

export default [
	{
		path: 'servicos/concursos-2023',
		component: Base,
		children: [
			{
				path: '',
				name: 'ListCategoriasConcursos2023',
				component: ListCategoriasConcursos2023,
				meta: {
					path: '/servicos/concursos-2023',
					pai: 'Serviços',
					title: 'Admin - Concursos 2023',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Concursos 2023',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			
			{
				path: 'novo',
				name: 'FormCategoriasConcursos2023',
				component: FormCategoriasConcursos2023,
				meta: {
					path: '/servicos/concursos-2023',
					pai: 'Serviços',
					title: 'Admin - Concursos 2023 - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Concursos 2023',
						class: '',
						active: false,
						url: '/servicos/concursos-2023'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			
			{
				path: 'editar/:id',
				name: 'FormCategoriasConcursos2023Editar',
				component: FormCategoriasConcursos2023,
				meta: {
					path: '/servicos/concursos-2023',
					pai: 'Serviços',
					title: 'Admin - Concursos 2023 - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Concursos 2023',
						class: '',
						active: false,
						url: '/servicos/concursos-2023'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			
			{
				path: ':id',
				name: 'ListConcursos2023',
				component: ListConcursos2023,
				meta: {
					path: '/servicos/concursos-2023',
					pai: 'Serviços',
					title: 'Admin - Concursos 2023 - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Concursos 2023',
						class: '',
						active: false,
						url: '/servicos/concursos-2023'
					},
					{
						pagina: 'Carregando...',
						class: '',
						active: true,
						url: false,
						newClass: 'menu-selecionado'
					}],
					noCache: true
				},
			},

			{
				path: ':id/novo',
				name: 'FormConcursos2023',
				component: FormConcursos2023,
				meta: {
					path: '/servicos/concursos-2023',
					pai: 'Serviços',
					title: 'Admin - Concursos 2023 - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Concursos 2023',
						class: '',
						active: false,
						url: '/servicos/concursos-2023'
					},
					{
						pagina: 'Carregando...',
						class: '',
						active: false,
						url: '/',
						ref: 'menuSelecionado'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},

			{
				path: ':id/editar/:cat',
				name: 'FormConcursos2023Editar',
				component: FormConcursos2023,
				meta: {
					path: '/servicos/concursos-2023',
					pai: 'Serviços',
					title: 'Admin - Concursos 2023 - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Concursos 2023',
						class: '',
						active: false,
						url: '/servicos/concursos-2023'
					},
					{
						pagina: 'Carregando...',
						class: '',
						active: false,
						url: '/',
						ref: 'menuSelecionado'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
		]
	}
]